import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { parsePhoneNumberFromString, getCountryCallingCode, getCountries } from 'libphonenumber-js';
import BaseInput from '../BaseInput';
import { useInput } from '../../form/hooks/useInput';
const PhoneNumber = forwardRef((props, ref) => {
    const { name, onChange, onBlur, defaultCountry = 'AM', country = null, maxLength = 14, placeholder, disabled, withCountryCallingCode = true, international = true, showCountrySelect = false, } = props;
    const { field } = useInput({ type: 'phone', name, onChange, onBlur });
    const [selectedCountry, setSelectedCountry] = useState(country || defaultCountry);
    const [inputValue, setInputValue] = useState('');
    useImperativeHandle(ref, () => ({
        // @ts-ignore
        ...field.ref,
        childType: 'phone',
    }));
    useEffect(() => {
        if (!selectedCountry) {
            setInputValue(field.value || '');
            return;
        }
        const countryCode = getCountryCallingCode(selectedCountry);
        const defaultPrefix = withCountryCallingCode ? `+${countryCode}` : '';
        if (!field.value || !field.value.startsWith('+')) {
            setInputValue(defaultPrefix);
            field.onChange(defaultPrefix);
        }
        else {
            const phoneNumber = parsePhoneNumberFromString(field.value, selectedCountry);
            if (phoneNumber) {
                setInputValue(international ? phoneNumber.formatInternational() : phoneNumber.formatNational());
            }
            else {
                setInputValue(field.value);
            }
        }
    }, [selectedCountry, withCountryCallingCode, international]);
    const handleChange = (e) => {
        let value = e.target.value.replace(/[^\d+]/g, ''); // Remove non-numeric chars except "+"
        if (selectedCountry) {
            const countryCode = getCountryCallingCode(selectedCountry);
            if (withCountryCallingCode) {
                if (!value.startsWith(`+${countryCode}`)) {
                    value = `+${countryCode}${value.replace('+', '')}`;
                }
                if (value === '+')
                    value = `+${countryCode}`;
            }
            else {
                value = value.replace(/^\+/, ''); // Remove + if `withCountryCallingCode = false`
            }
        }
        const phoneNumber = selectedCountry ? parsePhoneNumberFromString(value, selectedCountry) : null;
        const formattedValue = phoneNumber
            ? international
                ? phoneNumber.formatInternational()
                : phoneNumber.formatNational()
            : value;
        setInputValue(formattedValue);
        field.onChange(phoneNumber ? phoneNumber.number : value);
    };
    const handleKeyDown = (e) => {
        if (!selectedCountry)
            return;
        const countryCode = getCountryCallingCode(selectedCountry);
        const prefix = `+${countryCode}`;
        if (withCountryCallingCode && (e.key === 'Backspace' || e.key === 'Delete') && inputValue === prefix) {
            e.preventDefault();
        }
    };
    const handleCountryChange = (e) => {
        setSelectedCountry(e.target.value ? e.target.value : null);
    };
    return (React.createElement(BaseInput, { prefix: showCountrySelect ? (React.createElement("select", { value: selectedCountry || '', onChange: handleCountryChange, className: 'country-selector' },
            React.createElement("option", { value: '' }, "No country"),
            getCountries().map((country) => (React.createElement("option", { key: country, value: country },
                country,
                " (+",
                getCountryCallingCode(country),
                ")"))))) : null, ...props, disabled: disabled },
        React.createElement("div", { className: 'phone-number-container' },
            React.createElement("input", { type: 'tel', ...field, value: inputValue, className: 'phone-number-input', disabled: disabled, onKeyDown: handleKeyDown, onChange: handleChange, onBlur: field.onBlur, maxLength: maxLength, placeholder: placeholder }))));
});
export default PhoneNumber;
//# sourceMappingURL=index.js.map